// Footer link lists (sections/footer.liquid, docs/footer.md). Each list is a
// native details, closed on load. Below 750px it is an ordinary accordion.
// From 750px section-footer.css already shows the list whatever the state;
// this sets it open, so assistive technology hears "expanded", keeps it open
// and takes the summary out of the tab order. Crossing back below 750px closes
// the lists again. Nothing here runs on a phone until the width changes.
const wide = window.matchMedia('(min-width: 750px)');

function sync(closeOnPhone) {
  for (const details of document.querySelectorAll('.footer__disclosure')) {
    const summary = details.querySelector('summary');
    if (wide.matches) {
      details.open = true;
      summary.tabIndex = -1;
    } else {
      summary.removeAttribute('tabindex');
      if (closeOnPhone) details.open = false;
    }
  }
}

document.addEventListener('click', (event) => {
  if (wide.matches && event.target.closest('.footer__summary')) event.preventDefault();
});
wide.addEventListener('change', () => sync(true));
document.addEventListener('shopify:section:load', () => sync(false));
sync(false);

// Cookie preferences button in the legal line (docs/footer.md). Shopify's
// privacy banner script defines window.privacyBanner; showPreferences() reopens
// it at the preferences view, so a shopper can withdraw consent as easily as
// they gave it. The button stays hidden until that API exists (the banner can
// load after this module, and later still on a slow connection, so it is
// checked every half second for thirty seconds).
const showPreferences = () => window.privacyBanner?.showPreferences;

function revealCookiePreferences(attempt = 0) {
  const control = document.querySelector('[data-cookie-preferences]');
  if (!control) return;
  if (typeof showPreferences() === 'function') {
    control.hidden = false;
  } else if (attempt < 60) {
    window.setTimeout(() => revealCookiePreferences(attempt + 1), 500);
  }
}

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-cookie-preferences] button')) return;
  const open = showPreferences();
  if (typeof open === 'function') open.call(window.privacyBanner);
});
document.addEventListener('shopify:section:load', () => revealCookiePreferences());
revealCookiePreferences();
